export const getIsErrorInReplyForwardEditor = ({
  errors,
  values,
  temporaryInputValues,
  validate,
}): boolean => {
  const errorKeys = Object.keys(errors);

  let isError = false;

  errorKeys.forEach((key) => {
    if (key === 'to' || key === 'cc' || key === 'bcc') {
      if (temporaryInputValues[key] && !values[key].length) {
        isError = true;
      } else {
        const error = validate(key, values[key].length ? values[key]?.[0] : '');
        isError = isError || !!error;
      }
    } else {
      const error = validate(key, values[key]);
      isError = isError || !!error;
    }
  });

  return isError;
};
